import { fetchUtils } from '../../utils/fetchUtils'
import {
	type PlatformRequest,
	type PlatformRequestAttachment,
	type PlatformRequestLastSend,
	type PlatformRequestReceiver,
	type PlatformRequestSender,
	type PlatformRequestSendResponse
} from './PlatformRequest.model'

const baseUrl = '/api/platformRequest'

export async function getSender(lotId: string): Promise<PlatformRequestSender> {
	return await fetchUtils.get(`${baseUrl}/sender/${lotId}`, false)
}

export async function getReceiver(popId: string): Promise<PlatformRequestReceiver[]> {
	return await fetchUtils.get(`${baseUrl}/receiver/${popId}`, false).catch((e) => {
		console.error('Could not fetch recipients: ' + e)
		return []
	})
}

export async function getSubject(lotId: string): Promise<string> {
	return await fetchUtils.get(`${baseUrl}/subject/${lotId}`, false).catch((e) => {
		console.error('Could not fetch subject: ' + e)
		return ''
	})
}

export async function getMailTemplate(
	lotId: string,
	recipients: PlatformRequestReceiver[]
): Promise<string> {
	return await fetchUtils
		.post(`${baseUrl}/mailTemplate/${lotId}`, { recipients }, false)
		.catch((e) => {
			console.error('Could not fetch mailTemplate: ' + e)
			return ''
		})
}

export async function getAttachments(lotId: string): Promise<PlatformRequestAttachment[]> {
	return await fetchUtils.get(`${baseUrl}/fileInfo/${lotId}`, false).catch((e) => {
		console.error('Could not fetch attachments: ' + e)
		return []
	})
}

export async function getLastSend(lotId: string, popId: string): Promise<PlatformRequestLastSend> {
	return await fetchUtils.get(`${baseUrl}/lastSend/${lotId}/${popId}`, false).catch((e) => {
		console.error('Could not fetch lastSend: ' + e)
		return null
	})
}

export async function sendEmail(
	platformRequest: PlatformRequest,
	lotId: string,
	popId: string
): Promise<PlatformRequestSendResponse> {
	const recipients = platformRequest.recipients
	return await fetchUtils
		.post(
			`${baseUrl}/sendMail`,
			{
				...platformRequest,
				recipients: recipients,
				lotId: Number(lotId),
				popId: Number(popId)
			},
			false
		)
		.catch((e) => {
			console.error('Could not send email: ' + e)
			return e.data
		})
}
